import { render, staticRenderFns } from "./BaseErrorWindow.vue?vue&type=template&id=185171ca&"
import script from "./BaseErrorWindow.vue?vue&type=script&lang=js&"
export * from "./BaseErrorWindow.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BaseErrorWindow.vue?vue&type=style&index=0&lang=less&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports